<template>
  <div class="services" align="center" :style="pagepadding">
    <b-container>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
        <b-form-group id="input-group-2" label="Your Name:" label-for="name">
          <b-form-input
            id="name"
            v-model="form.name"
            type="text"
            required
            placeholder="* Enter name"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Email address:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="* Enter email"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Phone Number:"
          label-for="input-1"
        >
          <vue-tel-input
            id="input-1"
            v-on:validate="isPhoneValidValid = !isPhoneValidValid"
            v-model="form.tel"
            type="tel"
            required
            placeholder="* Enter phone number"
          ></vue-tel-input>
          <b-form-invalid-feedback :state="PhoneValidation">
            phone number is incorrect
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="input-group-1" label="Date:" label-for="input-1">
          <b-form-datepicker
            id="datepicker-buttons"
            v-model="form.date"
            type="date"
            placeholder="* Enter date"
            today-button
            reset-button
            close-button
            locale="en"
            :min="minDate"
            class="date"
          ></b-form-datepicker>
          <b-form-invalid-feedback :state="EmptyDateValidation">
            Date cannot be empty
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="input-group-1" label="Time:" label-for="input-1">
          <b-form-timepicker
            id="datepicker-valid"
            v-model="form.time"
            type="time"
            required
            locale="en"
            placeholder="* Enter time"
            :hour12="true"
          >
          </b-form-timepicker>
          <b-form-invalid-feedback :state="EmptyTimeValidation">
            Time cannot be empty
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Add Your Message:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="form.message"
            type="text"
            placeholder="Add Your Message"
          ></b-form-input>
        </b-form-group>

        <button type="submit" class="btn btn-primary" style="margin-right: 1em">
          Checkout
        </button>
        <b-button type="reset" variant="danger">Reset</b-button>
        <!-- <b-card class="mt-3" header="Form Data Result">
          <pre class="m-0">{{ form }}</pre>
        </b-card> -->
      </b-form>
    </b-container>
  </div>
</template>

<script>
const axios = require("axios");
// const stripe = window.Stripe("pk_test_heK0MBcZ6ibt4tYNbYr0g4Vu00K09tVdQS");
const stripe = window.Stripe("pk_live_ne38ZBltuMIz1CENiJ5gWhBs00OedogQf5");
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  name: "Book",
  data() {
    return {
      tryToSubmit: false,
      isPhoneValidValid: true,
      sessionId: "",
      minDate: new Date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        )
      ),

      form: {
        date: "",
        time: "",
        email: "",
        name: "",
        message: "",
        tel: "",
      },
      show: true,
    };
  },
  computed: {
    pagepadding() {
      if (window.innerWidth >= 768) {
        return "padding: 2em;";
      } else {
        return "padding: 5em 2em;";
      }
    },
    EmptyDateValidation() {
      return !(this.form.date == "" && this.tryToSubmit);
    },
    EmptyTimeValidation() {
      return !(this.form.time == "" && this.tryToSubmit);
    },
    PhoneValidation() {
      if (this.tryToSubmit) return this.isPhoneValidValid;
      return true;
    },
  },
  props: ["price"],
  components: {},
  created() {},
  methods: {
    makeToast(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    pay() {
      let data = {
        id: this.$store.state.currentProgram.id,
        Time: this.$store.state.currentProgram.Time,
        Price: this.$store.state.currentProgram.Price,
        description: this.$store.state.currentProgram.description,
      };
      let data2 = {
        date: this.form.date,
        time: this.form.time,
        email: this.form.email,
        name: this.form.name,
        message: this.form.message,
        tel: this.form.tel,
      };
      axios
        .get(
          "https://us-central1-shani-life-coaching.cloudfunctions.net/CheckoutSession",
          {
            params: {
              product: data,
              buyObject: data2,
            },
          }
        )
        .then((response) => {
          this.sessionId = response.data.id;

          // מכניס הכל לדיבי ושילם שווה פולס
          stripe
            .redirectToCheckout({
              // Make the id field from the Checkout Session creation API response
              // available to this file, so you can provide it as parameter here
              // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
              sessionId: this.sessionId,
            })
            .then(function (result) {
              // If `redirectToCheckout` fails due to a browser or network
              // error, display the localized error message to your customer
              // using `result.error.message`.
              console.log(result.error.message);
              this.makeToast(
                "Error",
                "Couldn't redirect to checkout, Please try again later...",
                "danger"
              );
              setTimeout(() => this.$router.push({ path: "/services" }), 3000);
            });
        })
        .catch((error) => {
          console.log(error);
          this.makeToast(
            "Error",
            "Couldn't redirect to checkout, Please try again later...",
            "danger"
          );
          setTimeout(() => this.$router.push({ path: "/services" }), 3000);
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.tryToSubmit = true;
      if (
        this.EmptyDateValidation &&
        this.EmptyTimeValidation &&
        this.isPhoneValidValid
      ) {
        this.pay();
      }
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.date = "";
      this.form.time = "";
      this.form.message = "";
      this.form.tel = "";
      this.tryToSubmit = false;
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>
<style>
/* .date {
} */
</style>
